import React from "react";
import Modal from "../../common/modal";
import CaseRequestDetails from "./CaseRequestDetails";
import CaseInitiation from "../newCase/transactionDetail/CaseInitiation";
import Util from "../../../util/util";
import Messages from "../../../configurations/messages";
import Toaster from "toastr";
import { DiscoverConstants } from "../../../configurations/discoverConfigs/discoverConstants";
import CaseUpdate from "../cases/caseDetail/CaseUpdate";
import DiscoverApi from "../../../api/DiscoverApi";
class CaseRequestModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formState: {
        transactionDetails: true,
        caseCreation: false
      },
      transactionDetail: null,
      fetchingTransacation: false,
      caseDetail: null,
      fetchingCase: false,
      cancelling: false
    };
    this.startCaseCreation = this.startCaseCreation.bind(this);
    this.cancelCaseCreation = this.cancelCaseCreation.bind(this);
    this.getTransactionDetails = this.getTransactionDetails.bind(this);
    this.getCaseDetails = this.getCaseDetails.bind(this);
    this.cancelCaseRequest = this.cancelCaseRequest.bind(this);
  }

  startCaseCreation() {
    if (
      this.props.caseRequest.requestType ===
      DiscoverConstants.CaseRequestTypes.caseCreation
    ) {
      if (this.state.transactionDetail) {
        this.setState({
          formState: {
            ...this.state.formState,
            transactionDetails: false,
            caseCreation: true
          }
        });
      } else {
        this.getTransactionDetails(this.props.caseRequest.transactionReference);
      }
    } else if (
      this.props.caseRequest.requestType ===
      DiscoverConstants.CaseRequestTypes.caseUpdate
    ) {
      if (this.state.caseDetail) {
        this.setState({
          formState: {
            ...this.state.formState,
            transactionDetails: false,
            caseCreation: true
          }
        });
      } else {
        this.getCaseDetails(this.props.caseRequest.caseNumber);
      }
    }
  }

  cancelCaseRequest() {
    this.setState({ cancelling: true });
    DiscoverApi.cancelCaseRequest(this.props.caseRequest.id)
      .then(response => {
        this.setState({ cancelling: false });
        Toaster.success(Messages.SUCCESS_CANCEL_CASE_REQUEST);
        this.props.onRequestClose(true);
      })
      .catch(error => {
        Util.errorMessageToast(Toaster, error.data, [
          `${Messages.ERROR_CANCELLING_CASE_REQUEST}`
        ]);
        this.setState({ cancelling: false });
      });
  }

  cancelCaseCreation() {
    this.setState({
      formState: {
        transactionDetails: true,
        caseCreation: false
      }
    });
  }

  getCaseDetails(caseNumber) {
    this.setState({ fetchingCase: true });
    DiscoverApi.getDiscoverCase(caseNumber)
      .then(response => {
        let data = response.data;
        data = {
          ...data,
          createdOn: Util.toUserLocalTime(data.createdOn)
        };
        this.setState({
          formState: {
            ...this.state.formState,
            transactionDetails: false,
            caseCreation: true
          },
          caseDetail: data,
          fetchingCase: false
        });
      })
      .catch(error => {
        Util.errorMessageToast(Toaster, error.data, [
          `${Messages.ERROR_CASES}`
        ]);
        this.setState({ fetchingCase: false });
      });
  }

  getTransactionDetails(transactionReference) {
    this.setState({ fetchingTransacation: true });
    DiscoverApi.findDiscoverTransaction(transactionReference)
      .then(response => {
        let data = response.data;
        if (data && !data.dnCaseNumber) {
          this.setState({
            formState: {
              ...this.state.formState,
              transactionDetails: false,
              caseCreation: true
            },
            transactionDetail: data,
            fetchingTransacation: false
          });
        } else {
          this.setState({
            transactionDetail: data,
            fetchingTransacation: false
          });
        }
      })
      .catch(error => {
        this.setState({
          fetchingTransacation: false
        });
        Util.errorMessageToast(Toaster, error.data, [
          `${Messages.ERROR_TRANSACTION_SEARCH}`
        ]);
      });
  }

  render() {
    const { caseRequest, isOpen, onRequestClose } = this.props;
    const {
      formState,
      transactionDetail,
      fetchingTransacation,
      fetchingCase,
      caseDetail,
      cancelling
    } = this.state;
    return (
      <Modal
        title={caseRequest.caseNumber}
        isOpen={isOpen}
        onRequestClose={e => {
          if (formState.caseCreation) {
            if (window.confirm("Are you sure you want to exit?"))
              onRequestClose(e);
          } else {
            onRequestClose(e);
          }
        }}
      >
        {formState.transactionDetails && (
          <CaseRequestDetails
            transactionDetails={transactionDetail}
            caseRequest={caseRequest}
            startCaseCreation={this.startCaseCreation}
            fetchingTransacation={fetchingTransacation}
            fetchingCase={fetchingCase}
            cancelling={cancelling}
            cancelCaseRequest={this.cancelCaseRequest}
          />
        )}

        {formState.caseCreation && (transactionDetail || caseDetail) ? (
          <div>
            {caseRequest.requestType ===
            DiscoverConstants.CaseRequestTypes.caseCreation ? (
              <CaseInitiation
                caseDetail={caseRequest}
                transactionDetails={transactionDetail}
                inboundRequest={caseRequest.inboundRequest}
                cancelCaseCreation={this.cancelCaseCreation}
                closeModal={onRequestClose}
              />
            ) : caseRequest.requestType ===
              DiscoverConstants.CaseRequestTypes.caseUpdate ? (
              <div>
                <hr />
                <CaseUpdate
                  caseDetails={caseDetail}
                  caseRequest={caseRequest}
                  inboundRequest={caseRequest.inboundRequest}
                />
              </div>
            ) : (
              ""
            )}
          </div>
        ) : null}
      </Modal>
    );
  }
}

export default CaseRequestModal;



// WEBPACK FOOTER //
// ./src/components/discover/caseRequests/CaseRequestModal.js